import { render } from "./contactSecond.vue?vue&type=template&id=d50a803a&scoped=true"
import script from "./contactSecond.vue?vue&type=script&lang=js"
export * from "./contactSecond.vue?vue&type=script&lang=js"

import "./contactSecond.vue?vue&type=style&index=0&id=d50a803a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50a803a"]])

export default __exports__